import { createSlice } from '@reduxjs/toolkit';

export const bilsoftSlice = createSlice({
    name: 'bilsoft',
    initialState: {
        webServiceReq: null,
        programReq: null,
        databaseFetchLoading: false,
        availableDatabases: [],
        loginSuccess: false,
        loginToken: null
    },
    reducers: {
        updateCompanyReq: (state, action) => {
            state.companyReq = state.companyReq.map((item) => {
                if (item.title === action.payload.title) {
                    item.value = action.payload.value;
                }
                return item;
            });
        },
        setWebservicesReq: (state, action) => {
            state.webServiceReq = action.payload;
        },
        updateWebServiceReq: (state, action) => {
            state.webServiceReq[action.payload.title] = action.payload.value;
        },
        setProgramReq: (state, action) => {
            state.programReq = action.payload;
        },
        updateProgramReq: (state, action) => {
            state.programReq[action.payload.title] = action.payload.value;
        },
        setDatabaseFetchLoading: (state, action) => {
            state.databaseFetchLoading = action.payload;
        },
        setAvailableDatabases: (state, action) => {
            state.availableDatabases = action.payload;
        },
        setLoginSuccess: (state, action) => {
            state.loginSuccess = action.payload;
        },
        setLoginToken: (state, action) => {
            state.loginToken = action.payload;
        },
        clearBilsoftState: (state) => {
            state.webServiceReq = null;
            state.programReq = null;
            state.databaseFetchLoading = false;
            state.availableDatabases = [];
            state.loginSuccess = false;
            state.loginToken = null;
        }
    }
});

export const { 
    updateCompanyReq, 
    updateWebServiceReq, 
    setWebservicesReq, 
    setProgramReq, 
    updateProgramReq,
    setDatabaseFetchLoading,
    setAvailableDatabases,
    setLoginSuccess,
    setLoginToken,
    clearBilsoftState
} = bilsoftSlice.actions;

export default bilsoftSlice.reducer;
